import * as maritalStatuses from 'constants/enums/maritalStatuses'

export default {
  [maritalStatuses.SINGLE]: 'Svobodný,á',
  [maritalStatuses.MARRIED]: 'Ženatý, vdaná',
} as const
